cv.WizardBehavior = Marionette.Behavior.extend({
    // you can set default options
    // just like you can in your Backbone Models
    // they will be overriden if you pass in an option with the same key
    defaults: {
    },

    // behaviors have events that are bound to the views DOM
    events: {
      'click .pagination .prev' : 'previousPage',
      'click .pagination .next' : 'nextPage'
    },

    collectionEvents: {
      'reset' : 'collectionReset',
      'request' : 'collectionRequest',
      'sync' : 'collectionSync'
    },

    collectionReset: function(collection){
      this.view.$childViewContainer.before(cv.Templates['partials/pagination']());
      this.view.$childViewContainer.after(cv.Templates['partials/pagination']());

      this.$('.pagination .caption').html(collection.caption);
      if(collection.params.offset == 0 && collection.params.limit <= collection.num_records){
        this.$('.pagination a.next').show();
      }
      if(collection.params.offset + collection.params.limit > collection.num_records && collection.params.limit <= collection.num_records){
        this.$('.pagination a.prev').show();
      }
    },

    collectionRequest: function(collection){
      console.log('Fetching...');

      this.$('.pagination').remove();
      this.view.$childViewContainer.html(cv.Templates['partials/loader']());
    },

    collectionSync: function(collection){
      console.log('Fetch complete.');

      this.$('.loader').remove();
    },

    previousPage: function(e){
      e.preventDefault();

      this.view.collection.previousPage();
    },

    nextPage: function(e){
      e.preventDefault();

      this.view.collection.nextPage();
    }
});